import { Info } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Widget } from "@/components/consultation/shared/Widget";
import type { PatientInfo } from "@/types/appointments";

interface PatientInfoCompactCardProps {
  patientInfo?: PatientInfo;
}

export const PatientInfoCompactCard = ({
  patientInfo,
}: PatientInfoCompactCardProps) => {
  return (
    <Widget className="p-3 flex flex-col gap-2">
      <div className="flex flex-wrap items-center gap-1.5">
        {patientInfo?.zarity_id && (
          <Badge
            variant="secondary"
            className="z-caption tabular-nums h-5 px-2 border-0"
          >
            #{patientInfo.zarity_id}
          </Badge>
        )}
        <Badge variant="outline" className="gap-1 z-caption h-5 px-2">
          <Info className="size-3" />
          Baseline Consultation
        </Badge>
      </div>

      <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
        <Metric
          label="Age/Sex"
          value={`${patientInfo?.age || "—"} / ${patientInfo?.sex || "—"}`}
        />
        <Metric
          label="BMI"
          value={
            patientInfo?.bmi?.bmi != null ? String(patientInfo.bmi.bmi) : "—"
          }
          numeric
        />
        <Metric
          label="Speaks"
          value={patientInfo?.languages?.join("  ") || "—"}
        />
      </div>
    </Widget>
  );
};

function Metric({
  label,
  value,
  numeric,
}: {
  label: string;
  value: string;
  numeric?: boolean;
}) {
  return (
    <span className="flex items-center gap-1.5">
      <span className="z-eyebrow text-muted-foreground">{label}</span>
      <Badge
        variant="secondary"
        className={`z-caption h-5 px-2 border-0 ${numeric ? "tabular-nums" : ""}`}
      >
        {value}
      </Badge>
    </span>
  );
}
